import React, { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import Table from "../../Components/Script/Table";
import { generatePaymentLink, getAllLoans } from "../../Services/loanServices";

function AllLoansAdmin() {
    const [loans, setLoans] = useState([]);
    const [expandedLoanId, setExpandedLoanId] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [previewFile, setPreviewFile] = useState(null);

    const openPreview = (fileUrl) => {
        setPreviewFile(fileUrl);
    };

    const closePreview = () => {
        setPreviewFile(null);
    };

    const openImagePreview = (imageUrl) => {
        setPreviewImage(imageUrl);
    };

    const closeImagePreview = () => {
        setPreviewImage(null);
    };

    const toggleDetails = (loanId) => {
        setExpandedLoanId(prev =>
            prev === loanId ? null : loanId
        );
    };

    const getFileType = (url) => {
        if (!url) return "unknown";

        const ext = url.split(".").pop().toLowerCase();

        if (["jpg", "jpeg", "png", "webp"].includes(ext)) return "image";
        if (ext === "pdf") return "pdf";
        return "other";
    };

    const getFileMeta = (url) => {
    if (!url) return { type: "unknown", icon: "mdi-file", name: "" };

    const parts = url.split("/");
    const fileName = parts[parts.length - 1];
    const ext = fileName.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "webp"].includes(ext))
        return { type: "image", icon: null, name: fileName };

    if (ext === "pdf")
        return { type: "pdf", icon: "mdi-file-pdf-box", name: fileName };

    if (["doc", "docx"].includes(ext))
        return { type: "doc", icon: "mdi-file-word-box", name: fileName };

    if (["xls", "xlsx"].includes(ext))
        return { type: "xls", icon: "mdi-file-excel-box", name: fileName };

    return { type: "other", icon: "mdi-file", name: fileName };
};

const renderDocument = (fileUrl) => {
    if (!fileUrl) return "-";

    const meta = getFileMeta(fileUrl);

    // IMAGE THUMBNAIL
    if (meta.type === "image") {
        return (
            <img
                src={fileUrl}
                className="img-thumbnail"
                style={{ maxHeight: "80px", cursor: "pointer" }}
                onClick={() => openPreview(fileUrl)}
            />
        );
    }

    // FILE ICON + NAME
    return (
        <div
            style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}
            onClick={() => openPreview(fileUrl)}
        >
            <i className={`mdi ${meta.icon} fs-3 text-danger`}></i>
            <span className="text-truncate" style={{ maxWidth: "140px" }}>
                {meta.name}
            </span>
        </div>
    );
};




    const user = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        fetchLoans();
    }, []);

    const fetchLoans = async () => {
        const data = await getAllLoans(user.id);
        setLoans(data);
    };

    const handleGeneratePayment = async (loanId) => {
        try {
            await generatePaymentLink(loanId);
            alert("Payment link sent to customer");
            fetchLoans();
        } catch (err) {
            alert("Failed to generate payment link");
        }
    };

    return (
        <>
            <Table />

            <div className="wrapper">
                <div className="content-page">
                    <div className="content">

                        <div className="container-fluid">

                            {/* PAGE TITLE */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li className="breadcrumb-item active">Loan Applications</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">Loan Applications</h4>
                                    </div>
                                </div>
                            </div>

                            {/* TABLE */}
                            <div className="card">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Full Name</th>
                                                    <th>Mobile</th>
                                                    <th>Email</th>
                                                    <th>Loan Type</th>
                                                    {/* <th>Status</th> */}
                                                    <th>Payment</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loans.length > 0 ? (
                                                    loans.map((loan) => (
                                                        <React.Fragment key={loan.id}>
                                                            {/* MAIN ROW */}
                                                            <tr>
                                                                <td>{new Date(loan.createdAt).toLocaleDateString("en-GB")}</td>
                                                                <td
                                                                    style={{ cursor: "pointer", color: "#0d6efd" }}
                                                                    onClick={() => toggleDetails(loan.id)}
                                                                >
                                                                    {loan.fullName}
                                                                </td>
                                                                <td>{loan.mobile}</td>
                                                                <td>{loan.email}</td>
                                                                <td>{loan.loanType}</td>
                                                                <td>
                                                                    {loan.paymentStatus === "Paid" ? (
                                                                        <span className="badge bg-success">Paid</span>
                                                                    ) : (
                                                                        <span className="badge bg-warning">Unpaid</span>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {loan.paymentStatus !== "Paid" && (
                                                                        <button
                                                                            className="btn btn-sm btn-primary"
                                                                            onClick={() => handleGeneratePayment(loan.id)}
                                                                        >
                                                                            Send Payment Link
                                                                        </button>
                                                                    )}
                                                                </td>
                                                            </tr>

                                                            {/* EXPANDED DETAILS ROW */}
                                                            {expandedLoanId === loan.id && (
                                                                <tr className="bg-light">
                                                                    <td colSpan="7">
                                                                        <div className="row">
                                                                            <div className="col-md-4">
                                                                                <strong>Aadhaar</strong><br />
                                                                                {renderDocument(loan.aadhaarPath)}
                                                                            </div>

                                                                            <div className="col-md-4">
                                                                                <strong>PAN</strong><br />
                                                                                {renderDocument(loan.panPath)}
                                                                            </div>

                                                                            <div className="col-md-4">
                                                                                <strong>Photo</strong><br />
                                                                               {renderDocument(loan.photoPath)}
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))


                                                ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">
                                                            No Loan Applications Found
                                                        </td>
                                                    </tr>
                                                )

                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {previewFile && (
                <div className="image-preview-overlay" onClick={closePreview}>
                    <div
                        className="image-preview-container"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="btn btn-danger btn-sm close-btn"
                            onClick={closePreview}
                        >
                            ✖
                        </button>

                        {getFileType(previewFile) === "image" && (
                            <img src={previewFile} alt="Preview" />
                        )}

                        {getFileType(previewFile) === "pdf" && (
                            <iframe
                                src={previewFile}
                                title="PDF Preview"
                                width="100%"
                                height="600px"
                                style={{ border: "none" }}
                            />
                        )}

                        {getFileType(previewFile) === "other" && (
                            <div className="text-center p-4">
                                <p>Preview not supported</p>
                                <a
                                    href={previewFile}
                                    className="btn btn-primary"
                                    download
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Download File
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            )}


            <Outlet />
        </>
    );
}

export default AllLoansAdmin;
